/* eslint-disable no-tabs */
<template>
  <v-container>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step
          :complete="e1 > 1"
          step="1"
        >
          Registrar Tarea
        </v-stepper-step>

        <v-divider />

        <v-stepper-step
          :complete="e1 > 2"
          step="2"
        >
          Crear Tarea
        </v-stepper-step>

        <v-divider />

        <v-stepper-step step="3">
          Procesar Matriz de datos
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card
            class="mb-5"
          >
            <v-card-text>
              <v-text-field
                id="id"
                v-model="dataForm.name"
                name="name"
                solo
                label="Nombre de la tarea"
              />
              <v-select
                v-model="dataForm.extraction_type"
                :items="['Punto', 'Area']"
                solo
                label="Tipo de extracción"
              />
              <v-text-field
                v-if="dataForm.extraction_type =='Area'"
                id="id"
                v-model="dataForm.km"
                name="name"
                solo
                type="number"
                label="Kilometros de diametro"
              />
              <v-combobox
                v-model="dataForm.localities"
                solo
                :items="selects.localities"
                item-text="label"
                return-object
                item-value="value"
                multiple
                label="Localidades"
                :loading="loadingBtn"
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @click="toggleLocality"
                  >
                    <v-list-item-action>
                      <v-icon :color="dataForm.localities.length > 0 ? 'indigo darken-4' : ''">
                        {{ iconLocalities }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Seleccionar todos</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2" />
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index < 6">
                    <span>{{ item.label }}</span>
                  </v-chip>
                  <span
                    v-if="index === 6"
                    class="grey--text caption"
                  >(+{{ dataForm.localities.length - 6 }} Otros)</span>
                </template>
              </v-combobox>
              <v-combobox
                v-model="dataForm.layers"
                solo
                :items="selects.variables"
                item-value="id"
                multiple
                item-text="name"
                label="Variables"
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @click="toggleLayers"
                  >
                    <v-list-item-action>
                      <v-icon :color="dataForm.layers.length > 0 ? 'indigo darken-4' : ''">
                        {{ iconLayers }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Seleccionar todos</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2" />
                </template>
              </v-combobox>
              <label>Fecha de inicio</label>
              <v-text-field
                id="dateInit"
                v-model="dataForm.start_date"
                solo
                name="dateInit"
                type="date"
                label="Fecha de inicio"
              />
              <label>Fecha de finalización</label>
              <v-text-field
                id="dateEnd"
                v-model="dataForm.end_date"
                solo
                name="dateEnd"
                type="date"
                label="Fecha Finalización"
              />
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="warning"
                @click="closeModal()"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                :loading="loadingStore"
                @click="store()"
              >
                Guardar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card
            class="mb-5"
          >
            <v-card-title primary-title>
              <h3>{{ secondTitle }}{{ points }}</h3>
              <v-spacer />
              <v-btn
                text
                :loading="loadingStatus"
                :disabled="loadingStatus"
                @click="getStatus()"
              >
                <v-icon color="black">
                  fas fa-redo-alt
                </v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <div class="text-xs-center text-md-center">
                <div>
                  <v-progress-circular
                    :rotate="90"
                    :size="120"
                    :width="20"
                    :value="generalProgress"
                    :color="colorArray[colorArray.length - 1]"
                  >
                    {{ generalProgress }}
                  </v-progress-circular>
                </div>
                <v-layout
                  row
                  justify-center
                >
                  <v-flex
                    v-for="(stat, key) in progress"
                    :key="key"
                    xs3
                  >
                    <label>{{ stat.desc }}</label>
                    <br>
                    <v-progress-circular
                      :rotate="90"
                      :size="100"
                      :width="15"
                      :value="stat.pct_complete"
                      :color="colorArray[key]"
                    >
                      {{ stat.pct_complete }}
                    </v-progress-circular>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
          </v-card>
          <v-btn
            v-if="endTaskCreate"
            color="primary"
            :loading="loadingProcces"
            @click="proccessData()"
          >
            Continuar
          </v-btn>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-card
            class="mb-5"
            height="200px"
          >
            <v-card
              class="mb-5"
              height="200px"
            >
              <v-card-title primary-title>
                <h3>Procesando Matriz de datos</h3>
              </v-card-title>
              <v-card-text>
                <v-progress-linear :indeterminate="indeterminate.e3" />
                <material-notification
                  v-if="!indeterminate.e3"
                  class="mb-3"
                  color="success"
                >
                  <strong><v-icon color="white">fas fa-check</v-icon></strong> <v-divider vertical />La tarea esta lista para ser procesada
                </material-notification>
              </v-card-text>
            </v-card>
          </v-card>
          <v-btn
            v-if="!indeterminate"
            color="primary"
            @click="endStore()"
          >
            Finalizar
          </v-btn>
          <v-btn
            text
            @click="endStore()"
          >
            Cancel
          </v-btn>
        </v-stepper-content>
        <v-stepper-content step="4">
          <v-card
            class="mb-5"
            height="200px"
          >
            <v-card
              class="mb-5"
              height="200px"
            >
              <v-card-title primary-title>
                <v-layout
                  row
                  wrap
                  justify-center
                >
                  <v-flex
                    xs6
                    text-xs-center
                  >
                    <h3>La tarea expiro</h3>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-actions>
                <v-btn
                  color="warning"
                  @click="endStore()"
                >
                  Eliminar Tarea
                </v-btn>
                <v-spacer />
                <v-btn color="success">
                  Restaurar tarea
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-snackbar
      v-model="alert.active"
      :color="alert.color"
    >
      {{ alert.message }}
      <v-btn
        text
        @click.native="alert.active = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
export default {
  props: [
    'step', 'taskData'
  ],
  data () {
    return {
      baseRoute: process.env.VUE_APP_URL + 'api/gis/',
      baseRoutePython: 'http://172.24.199.148/gis/',
      e1: this.step,
      loadingBtn: false,
      secondTitle: 'Creando tarea de recolección',
      typeExtract: '',
      loadingStatus: false,
      endTaskCreate: false,
      dataForm: {
        name: '',
        localities: [],
        layers: [],
        type: '',
        start_date: '',
        end_date: '',
        origin: 1
      },
      taskId: '',
      selects: {
        localities: [],
        variables: []
      },
      indeterminate: {
        e2: false,
        e3: false
      },
      counter: 0,
      interval: {},
      alert: {
        message: '',
        color: 'success',
        active: false,
        icon: ''
      },
      progress: [
        { desc: 'Initializing',  step: 1, pct_complete: 0 },
        { desc: 'Downloading', step: 2, pct_complete: 0 },
        { desc: 'Combining Data', step: 3, pct_complete: 0 },
        { desc: 'Extracting Quality', step: 4, pct_complete: 0 },
        { desc: 'Finalizing', step: 5, pct_complete: 0 }
      ],
      generalProgress: 0,
      colorArray: [],
      points: '.',
      loadingStore: false,
      loadingProcces: false,
      response: ''
    }
  },
  computed: {
    selectAllLocalities () {
      return this.dataForm.localities.length === this.selects.localities.length
    },
    selectSomeLocalities () {
      return this.dataForm.localities.length > 0 && !this.selectAllLocalities
    },
    iconLocalities () {
      if (this.selectAllLocalities) return 'mdi-close-box'
      if (this.selectSomeLocalities) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    selectAllLayers () {
      return this.dataForm.layers.length === this.selects.variables.length
    },
    selectSomeLayers () {
      return this.dataForm.layers.length > 0 && !this.selectAllLayers
    },
    iconLayers () {
      if (this.selectAllLayers) return 'mdi-close-box'
      if (this.selectSomeLayers) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    randomColor () {
      var letters = '0123456789ABCDEF'
      var color = '#'
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    }
  },
  watch: {
    taskData: function () {
      this.setIncourceData()
    },
    step: function () {
      this.setIncourceData()
    }
  },
  created () {
  },
  mounted () {
    this.getLocalities()
    this.randomiceColor()
    this.setIntervalStatus()
    this.getStatus()
    this.getVariables()
  },
  methods: {
    toggleLocality () {
      this.$nextTick(() => {
        if (this.selectAllLocalities || this.selectSomeLocalities) {
          this.dataForm.localities = []
        } else {
          this.dataForm.localities = this.selects.localities
        }
      })
    },
    toggleLayers () {
      this.$nextTick(() => {
        if (this.selectAllLayers || this.selectSomeLayers) {
          this.dataForm.layers = []
        } else {
          this.dataForm.layers = this.selects.variables
        }
      })
    },
    store () {
      this.loadingStore = true
      this.dataForm.origin = 1
      const formData = this.dataForm
      formData.layers = this.dataForm.layers.map(function (item) {
        return item.id
      })
      formData.localities = this.dataForm.localities.map(function (item) {
        return item.value
      })
      axios.post(this.baseRoute + 'dataRaw/store', formData).then((res) => {
        this.loadingStore = false
        if (res.data.status == 'pending') {
          this.taskId = res.data.task_id
          this.setIntervalStatus()
          this.$emmit('storeTask')
          this.closeModal()
        } else if (res.data == 'ERROR') {
          this.alert = {
            message: 'Hubó un error en la creación de la tarea',
            color: 'error',
            active: true,
            icon: 'fas fa-bell'
          }
        } else {
          this.alert = {
            message: res.data.message,
            color: 'error',
            active: true,
            icon: 'fas fa-bell'
          }
        }
      }).catch(() => {
        this.loadingStore = false
        this.alert = {
          message: 'Hubó un error en el servidor pruebe nuevamente',
          color: 'error',
          active: true,
          icon: 'fas fa-bell'
        }
      })
    },
    endStore () {
      this.$emit('endStore')
    },
    getVariables () {
      axios.get(this.baseRoute + 'variables/getSelect?id_type=download_all').then((res) => {
        this.selects.variables = res.data
      }).catch(() => {
        this.alert = {
          message: 'Hay un error interno en el servidor pruebe nuevamente mas tarde',
          color: 'error',
          active: true,
          icon: 'fas fa-bell'
        }
      })
    },
    getStatus () {
      this.loadingStatus = true
      if (this.dataForm.type == 'appears') {
        axios.get(this.baseRoute + 'dataRaw/getStatusTask/' + this.taskId).then((res) => {
          this.loadingStatus = false
          if (res.data == '404"') {
            window.clearInterval(this.interval)
          }
          if (res.data.status == 'done') {
            this.points = ''
            this.secondTitle = 'Tarea de recolección finallizada'
            this.progress = [
              {	desc: 'Initializing', step: 1, pct_complete: 100 },
              { desc: 'Downloading', step: 2, pct_complete: 100 },
              { desc: 'Combining Data', step: 3, pct_complete: 100 },
              { desc: 'Extracting Quality', step: 4, pct_complete: 100 },
              { desc: 'Finalizing', step: 5, pct_complete: 100 }
            ]
            this.generalProgress = 100
            this.endTaskCreate = true
            window.clearInterval(this.interval)
          } else if (res.data.status == 'expired') {
            this.e1 = 4
          } else if (res.data.status == 'pending') {
            this.points = ''
            this.secondTitle = 'Tarea de recolección finallizada'
            this.progress = [
              { desc: 'Initializing', step: 1, pct_complete: 0 },
              { desc: 'Downloading', step: 2, pct_complete: 0 },
              { desc: 'Combining Data', step: 3, pct_complete: 0 },
              { desc: 'Extracting Quality', step: 4, pct_complete: 0 },
              { desc: 'Finalizing', step: 5, pct_complete: 0 }
            ]
            this.generalProgress = 0
            this.endTaskCreate = false
            window.clearInterval(this.interval)
          } else {
            this.progress = res.data.progress.details
            this.generalProgress = res.data.progress.summary
            if (this.points.length < 4) {
              this.points += '.'
            } else {
              this.points = '.'
            }
          }
        }).catch((error) => {
          console.error(error)
          this.loadingStatus = false
          this.alert = {
            message: 'Parece que hay un problema intente nuevamente',
            color: 'error',
            active: true,
            icon: 'fas fa-bell'
          }
          window.clearInterval(this.interval)
        })
      } else if (this.dataForm.type == 'ftp') {
        axios({
          headers: {
            Accept: 'application/json',
            Authorization: null
          },
          method: 'GET',
          url: this.baseRoutePython + 'getStatus?id_task=' + this.taskId
        }).then((res) => {
          this.loadingStatus = false
          this.progress = res.data.message[0]
          if (this.progress[3].pct_complete == 100) {
            this.generalProgress = 100
            this.endTaskCreate = true
            window.clearInterval(this.interval)
          }
        }).catch(() => {
          this.loadingStatus = false
          this.alert = {
            message: 'Hay un error interno en el servidor pruebe nuevamente mas tarde',
            color: 'error',
            active: true,
            icon: 'fas fa-bell'
          }
          window.clearInterval(this.interval)
        })
      }
    },
    setIntervalStatus () {
      this.interval = window.setInterval(function () { this.getStatus() }.bind(this), 30000)
      this.indeterminate.e2 = true
      this.endTaskCreate = false
      this.getStatus()
    },
    getLocalities () {
      // window.clearInterval(this.interval);
      axios.get(this.baseRoute + 'district/getSelect/habilited').then((res) => {
        this.selects.localities = res.data
      }).catch(() => {

      })
    },
    closeModal () {
      this.$emit('closeModal')
    },
    randomiceColor () {
      var letters = '0123456789ABCDEF'
      var color = '#'
      for (var i = 0, l = 6; i < l; ++i) {
        color = '#'
        for (var j = 0; j < 6; j++) {
          color += letters[Math.floor(Math.random() * 16)]
        }
        this.colorArray[i] = color
      }
    },
    proccessData () {
      this.loadingProcces = true
      this.e1 = 3
      this.indeterminate.e3 = true
      if (this.dataForm.type == 'appears') {
        axios.get(this.baseRoute + 'dataRaw/proccess/' + this.taskId).then((res) => {
          this.loadingProcces = false
          this.indeterminate.e3 = false
          if (res.data == 'Exito') {
            this.alert = {
              message: res.data.message,
              color: 'success',
              active: true,
              icon: 'fas fa-bell'
            }
          } else {
            this.alert = {
              message: error.response.data.message,
              color: 'error',
              active: true,
              icon: 'fas fa-bell'
            }
          }
        }).catch((error) => {
          this.alert = {
            message: error.response.data.message,
            color: 'error',
            active: true,
            icon: 'fas fa-bell'
          }
        })
      } else {
        this.endStore()
      }
    },
    setIncourceData () {
      this.loadingStatus = false
      window.clearInterval(this.interval)
      if (this.step == 1) {
        this.e1 = 1
        this.dataForm = {
          name: '',
          localities: [],
          layers: [],
          type: '',
          start_date: '',
          end_date: ''
        }
        this.getVariables()
        this.taskId = ''
      } else if (this.step == 2) {
        this.e1 = 2
        this.dataForm = {
          name: this.taskData.name,
          localities: [],
          layers: [],
          type: this.taskData.type,
          start_date: this.taskData.start_date,
          end_date: this.taskData.end_date
        }
        this.selects = {
          localities: [],
          variables: []
        }
        this.taskId = this.taskData.task_id
        this.getStatus()
      }
    }
  }
}
</script>
